import { useCallback, useEffect, useState } from 'react';

import { PREF_CHANGED_EVENT } from './constants';
import { broadcastChange, readNotificationPref, writeNotificationPref } from './utils';

export const useNotificationPref = storageKey => {
  const [enabled, setEnabled] = useState(() => readNotificationPref(storageKey));

  const update = useCallback(
    next => {
      writeNotificationPref(storageKey, next);
      setEnabled(next);
      broadcastChange(storageKey, next);
    },
    [storageKey],
  );

  useEffect(() => {
    const onChange = e => {
      if (e?.detail?.key === storageKey) {
        setEnabled(!!e.detail.value);
      }
    };

    window.addEventListener(PREF_CHANGED_EVENT, onChange);

    return () => {
      window.removeEventListener(PREF_CHANGED_EVENT, onChange);
    };
  }, [storageKey]);

  return [enabled, update];
};
